import handleResponse from "@/assets/handle-response";
import wretch from "wretch";

export default ({ state, commit, dispatch }, member) => {
  member, dispatch;
  return wretch("/api/create-member")
    .auth(state.email)
    .formData(member)
    .post()
    .json()
    .then(handleResponse)
    .then(() => {
      dispatch("getAllMembers");
    })
    .catch(text => {
      commit("setSnack", {
        visible: true,
        color: "error",
        text
      });
    });
};
